// packages
import { createTrendsFeed } from './stores.js';
import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

// components
import PendingResultsModal from './components/PendingResultsModal.svelte';

async function main() {
  // must match `page` for this box in _data/embeds/custom.json
  const pageLevel = 'national';

  const element = findElementByIdInShadowDom(
    `pendingresultsmodal-${pageLevel}`
  );
  if (!element) return;

  let page = element.dataset.page;
  let trends = await createTrendsFeed();

  renderSvelteComponent(PendingResultsModal, element, {
    trends,
    page,
  });
}

main().catch(console.error);
